import { Component, Injector, Input, OnInit } from '@angular/core';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';
import { WidgetBaseComponent } from '../../widgetBase';

/**
 * AppendixPage Widget
 */
@Component({
  selector: 'appendix-page-widget',
  templateUrl: './appendix-page-widget.component.html',
  styleUrls: ['./appendix-page-widget.component.scss', '../../common/css/general.scss']
})
export class AppendixPageWidgetComponent extends WidgetBaseComponent implements OnInit {

  /**
   * Widget Guid
   */
  @Input() widgetGuid: string;

  /**
   * Widget Config
   */
  public appendixPageWidgetConfig: any;

  /**
  * Constructor
  */
  constructor(injector: Injector) {
    super(injector, 'appendixPage', false);
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    // will call registerEvents and onInitialized when config (this.widgetConfig and this.page) is ready
    this.initWidgetConfig();
    this.widgetResized();

    if (!this.widgetConfig.widgetSettings.currentLayout) {
      this.widgetConfig.widgetSettings.currentLayout = this.widgetConfig.widgetSettings.id;
    }

    if (!this.widgetConfig.widgetSettings.enabledButtonInfobar) {
      this.widgetConfig.widgetSettings.enabledButtonInfobar = true;
    }
  }

  /**
   * Called by base class to let widget register to various app events (like saving, loading, resizing etc)
   */
  registerEvents(): void {
    this.useReadOnlySaveChangesHandler();
  }

  /**
   * Called by base class to inform widget that it is initialized
   * Mostly used to define where widget data should be loaded from
   */
  onInitialized(): void {
    if (!this.widgetConfig.hashtagSupported) {
      this.widgetConfig.hashtagSupported = true;
    }
    this.loadReflist('ref_l3_appendix_page_appendix_number');
    this.loadReflist('ref_l3_appendix_page_appendix_description');

    this.mockupData$ = this.widgetService.loadEmpty().pipe(take(1));//This widget doesn't load data from the API

    this.widgetData$ = this.mockup ?
      this.mockupData$
      : of({});
  }

  /**
   * Called by base class to let widget preprocess loaded data if required
   */
  protected preprocessLoadedData(data): any {
    this.appendixPageWidgetConfig = this.getWidgetSettingsOrDefault('appendixPageWidgetConfig', {
      appendixNumberId: 0,
      appendixDescriptionId: 0,
      appendixDescriptionText: ''
    });

    return data;
  }

  /**
   * onValueChanged event handler
  * @param _e {any} Event object
   */
  public onValueChanged(_e: any) {
    this.setWidgetSettings('appendixPageWidgetConfig', this.appendixPageWidgetConfig);
  }

  /**
   * onAppendixDescriptionSelected event handler
  * @param _e {any} Event object
   */
  public onAppendixDescriptionSelected(_e: any) {
    const reflistEntry = this.reflists['ref_l3_appendix_page_appendix_description'].filter((entry) => { return entry.oid === this.appendixPageWidgetConfig.appendixDescriptionId; });
    if (reflistEntry?.length) {
      this.appendixPageWidgetConfig.appendixDescriptionText = reflistEntry[0].description;
    }
    else {
      this.appendixPageWidgetConfig.appendixDescriptionText = '';
    }
    this.onValueChanged(_e);
  }

  /**
   * onAppendixDescriptionTyped event handler
  * @param _e {any} Event object
   */
  public onAppendixDescriptionTyped(_e: any) {
    const reflistEntry = this.reflists['ref_l3_appendix_page_appendix_description'].filter((entry) => { return entry.description === this.appendixPageWidgetConfig.appendixDescriptionText; });
    if (reflistEntry?.length) {
      this.appendixPageWidgetConfig.appendixDescriptionId = reflistEntry[0].oid;
    }
    else {
      this.appendixPageWidgetConfig.appendixDescriptionId = 0;
    }
    this.onValueChanged(_e);
  }
}
